import React, { useEffect, useState } from "react";
import "./css.css";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { db } from "../config_firebase";
import {
    collection,
    addDoc,
    getDocs,
    doc,
  } from "firebase/firestore";

/**
 * @author
 * @function Login
 *
 **/

 export const Endscreen = (props) => {
    // const [pic, setPic] = useState(img1);
    const history = useNavigate();
    const [url, setUrl] = useState(window.location.href);
    const [userId, setUserId] = useState("");

    useEffect(() => {
        const iosa = url.split(",");
        setUserId(iosa[1]);
      }, []);    

    async function addclick(data) {
    const docRef = await addDoc(collection(db, "clicksdata"), {
        data,
    });
    }

    const next = () => {
        const payment_button = {
            time: Date.now(),
            userId: localStorage.getItem("user_id"),
            buttonType: "payment_button",
        };
        addclick(payment_button);
        console.log("g", userId);
        window.location.href = "https://connect.cloudresearch.com/participant/project/3d934f1a8ae94cccb9dafd4cd036df23/complete";    };
    
    return(
        <div className="main">
            <div className="text-center">
                <div className="thankyoumessage">
                    <h2>Thank you for participating in the study!</h2>
                    <h3>The study examined processes of user engagement and advice taking. 
                    <br></br>If you have any questions or comments, please email us at: meytale@post.bgu.ac.il</h3>
                    <br></br><br></br>
                    <div className="text-center">
                        <Button variant="outline-light" className="loginbutton" type="submit" onClick={next}>
                        Click for participation confirmation
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}